import { render } from "./BuildingWorksSvg.vue?vue&type=template&id=635651be"
import script from "./BuildingWorksSvg.vue?vue&type=script&lang=js"
export * from "./BuildingWorksSvg.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__